// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilGrayXXLight":"#F9F9FA","wrapper":"style_wrapper__3dtgS","video":"style_video__3O501","loader":"style_loader__2l9vA"};